import { useLocalization } from "@izettle/tenko-react"

import { Container, Content, Title2, WallSuccess } from "@/core/components/shared"

// eslint-disable-next-line @typescript-eslint/ban-types
export type ThankYouProps = {}

export const ThankYou = () => {
  const { text } = useLocalization()

  return (
    <Container>
      <Content withNoHeaderSpace>
        <WallSuccess style={{ flex: 1 }}>
          <img
            src="https://cdn.izettle.com/customers/success-stamp.svg"
            alt="success"
            height="128px"
            aria-hidden
          />
          <Title2>{text("SIGNUP_THANKS")}</Title2>
        </WallSuccess>
      </Content>
    </Container>
  )
}
